export enum MODE {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}

type Props = {
  mode?: MODE;
  className?: string;
};

export default Props;
